import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { UserCircleIcon } from 'app/common/presentation/icons'
import { isInstalledConnection } from 'app/connections/types'

import { Card } from 'components'

import { useConnection } from '../../components/ConnectionContext'
import styles from './Overview.module.scss'
import { getAccountDetails } from './getAccountDetails'

export const Overview = () => {
  const { t } = useTranslation('connections')
  const selectedConnection = useConnection()

  if (!isInstalledConnection(selectedConnection)) return null

  const details = getAccountDetails(selectedConnection, t)

  if (!details.length) return null

  return (
    <div className={styles.overview}>
      <Card icon={<UserCircleIcon />} title={t('manage.overview.accountsAndIds.title')}>
        <div className={styles.cardContent}>
          {details.map(({ label, value }, index) => (
            <Fragment key={label}>
              {index > 0 && <div className={styles.divider} />}
              <div className={styles.detailRow}>
                <span>{label}</span>
                <strong>{value}</strong>
              </div>
            </Fragment>
          ))}
        </div>
      </Card>
    </div>
  )
}
